module.exports = __webpack_public_path__ + "404.png";